import React from 'react';
import { css } from '@emotion/react';
import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';

const styles = {
  viewMoreCard: css`
    background-color: var(--bright-blue-lightest);
    border-left: 1px solid var(--bright-blue);
    display: flex;
    min-height: 250px;
  `,
  interiorText: css`
    font-size: 200%;
    margin: auto;

    a {
      text-decoration: none;

      &:focus,
      &:hover {
        text-decoration: underline;
      }
    }
  `,
};

const ViewMoreResourcesCard = ({
  href,
}) => {
  return (
    <div css={styles.viewMoreCard}>
      <div css={styles.interiorText}>
        <a href={href}>
          View all <ChevronRightIcon />
        </a>
      </div>
    </div>
  );
};

export default ViewMoreResourcesCard;
